import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';
import {datadogLogs} from "@datadog/browser-logs";

if (environment.production) {
  enableProdMode();
}

if (environment.ddg_enabled) {
  datadogRum.init({
      applicationId: '75c8ce09-7ada-4728-96ac-68c2d1501524',
      clientToken: 'pub9d3d290b453fbc550e464aaa5088da61',
      site: 'datadoghq.com',
      service: 'app-xref-com',
      env: environment.env,
      sampleRate: 100,
      sessionReplaySampleRate: 0,
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingOrigins: [/https:\/\/.*\.xref\.com/, /https:\/\/.*\.xref\.io/ ]
      });
    datadogRum.startSessionReplayRecording();
    datadogLogs.init({
      service: 'app-xref-com',
      env: environment.env,
      clientToken: 'pub9d3d290b453fbc550e464aaa5088da61',
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      forwardConsoleLogs: "all",
      sampleRate: 100
  });
}


platformBrowserDynamic().bootstrapModule(AppModule,
  {}
)
  .catch(err => console.error(err));
